/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerCompanyAddressResource
 */
export interface FreelancerCompanyAddressResource {
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddressResource
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddressResource
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddressResource
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddressResource
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddressResource
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddressResource
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyAddressResource
     */
    formattedAddress?: string;
}

/**
 * Check if a given object implements the FreelancerCompanyAddressResource interface.
 */
export function instanceOfFreelancerCompanyAddressResource(value: object): value is FreelancerCompanyAddressResource {
    return true;
}

export function FreelancerCompanyAddressResourceFromJSON(json: any): FreelancerCompanyAddressResource {
    return FreelancerCompanyAddressResourceFromJSONTyped(json, false);
}

export function FreelancerCompanyAddressResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompanyAddressResource {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'city': json['city'] == null ? undefined : json['city'],
        'street': json['street'] == null ? undefined : json['street'],
        'region': json['region'] == null ? undefined : json['region'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
    };
}

export function FreelancerCompanyAddressResourceToJSON(value?: FreelancerCompanyAddressResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countryCode': value['countryCode'],
        'country': value['country'],
        'city': value['city'],
        'street': value['street'],
        'region': value['region'],
        'zipCode': value['zipCode'],
        'formattedAddress': value['formattedAddress'],
    };
}

